import resourceService from './resource_service';

const modelName = 'pump';

const attributes = {
  unitPumpId: '',
};

const relationships = {
  allocationUnit: {
    jsonApi: 'hasOne',
  },
  manifold: {
    jsonApi: 'hasOne',
  },
  chemical: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
